import { ActivityItemGridView } from '../view/ActivityGridView';
import { templateActivityGrid } from '../view/template';
import { BaseWebComponentController } from '../../../framework/BaseWebComponentController';
import { ActivityGridWebComponent } from '../component/ActivityGridWebComponent';
import { ActivityGridRepository } from '../repository/ActivityGridRepository';
import { ActivityGridViewData } from '../types';

export class ActivityGridController extends BaseWebComponentController {
  public component: ActivityGridWebComponent;
  public view: ActivityItemGridView;
  public viewConstructor: typeof ActivityItemGridView;
  public dataRepository: ActivityGridRepository;
  public dataRepositoryConstructor: typeof ActivityGridRepository;

  constructor(component: ActivityGridWebComponent) {
    super(component);

    this.initialSetup({
      viewConstructor: ActivityItemGridView,
      viewTemplate: templateActivityGrid,
      dataRepositoryConstructor: ActivityGridRepository,
    });
  }

  public async getDataForView(): Promise<ActivityGridViewData> {
    const res = await this.dataRepository.getDataForView();

    const displayedColumns = res.views[0].displayedColumns;
    const selectedTargets = res.views[0].selectedTargets;
    const filters = res.views[0].filters;

    return {
      targets: res.targets,
      isPartner: res.isPartner,
      allColumns: res.allColumns,
      views: res.views.map(view => {
        return {
          id: view.id,
          name: view.name,
          type: view.type,
          selectedTargets: selectedTargets,
          displayedColumns: displayedColumns,
          filters: filters,
          compactView: view.compactView,
          pageSize: view.pageSize,
        };
      }),
      defaultViewProps: res.defaultViewProps,
    };
  }

  computeEventListeners() {
    this.view.dom.$gridView.onDataLoadingStarted = this.onDataLoadingStarted.bind(this);
    this.view.dom.$gridView.onDataLoadingFinishedWithSuccess = this.onDataLoadingFinishedWithSuccess.bind(this);

    return [
      {
        element: this.view.dom.$deleteAllActivitiesBtn,
        event: 'click',
        callback: this.showDeleteAllConfirmationDialog,
      },
    ];
  }

  private showDeleteAllConfirmationDialog() {
    this.view.showDeleteAllConfirmationDialog();
  }

  private onDataLoadingStarted() {
    this.view.disableDeleteAllActivitiesBtn(true);
  }

  private async onDataLoadingFinishedWithSuccess() {
    const activitiesNo = await this.view.dom.$gridView.dataProvider.getActivitiesNumberForEndpoint();
    if (activitiesNo > 0) {
      this.view.disableDeleteAllActivitiesBtn(false);
      this.view.setTooltipForDeleteAllActivitiesBtn('');
    }
  }
}
